import React from 'react';
import { Link } from 'react-router-dom';
import './styles.css';

const NotFound = () => {
  return (
    <div className="page-container">
      <header className="header">
        <div className="logo">
          <h1>RENOV-PISCINES 13</h1>
        </div>
        <nav className="navigation">
          <ul>
            <li><Link to="/">Accueil</Link></li>
            <li><Link to="/projets">Nos précédents chantiers</Link></li>
            <li><Link to="/contact">Nous contacter</Link></li>
          </ul>
        </nav>
        <div className="hamburger-menu">
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </header>

      <main>
        <section className="hero" style={{ textAlign: 'center' }}>
          <div className="hero-content" style={{ width: '100%', paddingRight: '0' }}>
            <h2>Page non trouvée</h2>
            <p>Désolé, la page que vous recherchez n'existe pas ou a été déplacée.</p>
            <div style={{ marginTop: '2rem' }}>
              <Link to="/" className="btn-primary">Retourner à l'accueil</Link>
            </div>
          </div>
        </section>

        <section className="services">
          <h2>Peut-être cherchiez-vous...</h2>
          <div className="services-container">
            <div className="service-card">
              <div className="service-icon">💧</div>
              <h3>Nos services</h3>
              <p>Découvrez nos prestations de rénovation de piscines, pose de PVC armé et modernisation d'équipements.</p>
              <Link to="/" className="btn-secondary">Voir nos services</Link>
            </div>

            <div className="service-card">
              <div className="service-icon">🏊</div>
              <h3>Nos réalisations</h3>
              <p>Consultez nos précédents chantiers pour vous inspirer et voir la qualité de notre travail.</p>
              <Link to="/projets" className="btn-secondary">Voir nos projets</Link>
            </div>

            <div className="service-card">
              <div className="service-icon">📞</div>
              <h3>Nous contacter</h3>
              <p>Besoin d'un devis ou d'informations ? N'hésitez pas à nous contacter directement.</p>
              <Link to="/contact" className="btn-secondary">Contactez-nous</Link>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>RENOV-PISCINES 13</h3>
            <p>Votre spécialiste de la rénovation de piscines dans les Bouches-du-Rhône.</p>
          </div>
          <div className="footer-section">
            <h3>Contact</h3>
            <p>Email: renovpiscines13@outlook.fr</p>
            <p>Téléphone: 06 51 51 29 93</p>
          </div>
          <div className="footer-section">
            <h3>Horaires</h3>
            <p>Lundi - Vendredi: 8h - 19h</p>
            <p>Samedi: 8h - 12h</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 RENOV-PISCINES 13. Tous droits réservés.</p>
        </div>
      </footer>
    </div>
  );
};

export default NotFound;